module.exports = __webpack_public_path__ + "static/media/TUSD.938fdd22.svg";